import React from "react";
import commandList from "../commands";

function Command() {
  const commands = commandList.map((command, index) => {
    const oddStyling = "border-[0.5rem rounded-2xl";
    return (
      <div
        className={`pt-4 pb-4 pl-4 rounded-2xl ${
          index % 2 === 1 && "bg-[var(--secondary-colour)]"
        }`}
        key={index}
      >
        <h3
          className={`md:text-2xl font-semibold ${
            index % 2 === 0 && oddStyling
          }`}
        >
          {command.command}
        </h3>
        <p className="mt-2 md:text-xl">{command.desc}</p>
      </div>
    );
  });

  return (
    <section id="commands" className="border-x-2 border-dashed border-black">
      <div className="w-4/5 mx-auto my-0 py-20">
        <h2 className="text-4xl md:text-6xl mb-4">Commands</h2>
        <p className="md:text-2xl mb-4">
          Use these commands to get the most out of Fishcord.
        </p>
        <div className="bg-[var(--tertiary-colour)] rounded-2xl border-[0.5rem] border-[var(--tertiary-colour)]">
          {commands}
        </div>
      </div>
    </section>
  );
}

export default Command;
